// Company information for LEION Engineering
const ESTABLISHED_YEAR = 2009;

export const COMPANY_INFO = {
  name: 'LEION Engineering',
  tagline: 'Ultimate Technology to Perform',
  established: String(ESTABLISHED_YEAR),
  certification: 'ISO 9001:2008 Certified',
  
  contact: {
    phone: ['+91 98910 68221', '+91 92783 65125'],
    email: ['info@leiongroup.com'],
    website: 'www.leiongroup.com',
  },
  
  address: {
    office: '2420 & 2422, DLF City, DLF Phase-IV',
    city: 'Gurgaon',
    state: 'Haryana',
    country: 'India',
    pincode: '122002',
  },
  
  stats: {
    // Counted at build time (react-snap prerender), so a new year shows after the next deploy.
    yearsExperience: `${new Date().getFullYear() - ESTABLISHED_YEAR}+`,
    installations: '500+',
    countries: '15+',
    products: '50+',
    customers: '1000+',
  },
  
  certifications: [
    { name: 'ISO 9001:2008', description: 'Quality Management System' },
    { name: 'CE Marking', description: 'European Conformity' },
    { name: 'OIML', description: 'International Legal Metrology' },
  ],
  
  values: [
    {
      title: 'Precision',
      description: 'Accuracy is not negotiable. Every product meets the highest metrological standards.',
    },
    {
      title: 'Reliability',
      description: 'Built to perform in the harshest conditions. Our products are engineered for longevity.',
    },
    {
      title: 'Innovation',
      description: 'Continuous R&D investment ensures cutting-edge solutions for evolving industry needs.',
    },
    {
      title: 'Service',
      description: 'Global support network with rapid response times and comprehensive after-sales care.',
    },
  ],
  
  milestones: [
    { year: String(ESTABLISHED_YEAR), event: 'Company Founded in Gurgaon, India' },
    { year: '2010', event: 'Expanded to International Markets' },
    { year: '2015', event: '100th Weighbridge Installation' },
    { year: '2018', event: 'Launched Weigh-in-Motion Systems' },
    { year: '2020', event: 'Digital Transformation - IoT Integration' },
    { year: '2023', event: '500+ Global Installations Milestone' },
  ],
  
  team: [
    {
      name: 'Engineering Team',
      description: '25+ qualified engineers with expertise in mechanical, electrical, and software domains.',
    },
    {
      name: 'Service Network',
      description: 'Pan-India service coverage with international support partnerships.',
    },
    {
      name: 'Quality Control',
      description: 'Dedicated QC team ensuring every product meets stringent quality standards.',
    },
  ],
};

export const AUTHOR_INFO = {
  name: 'Ashutosh Gauniyal',
  title: 'Certified Author',
  creditLine: 'Certified Author and website developer',
};

export const LOGO_URL = '/assets/leion-logo-enhanced.png';
export const FOOTER_LOGO_URL = LOGO_URL;
